//import store from "../../store";
const redaktionenRoutes = [
  {
    path: "/Redaktionen",
    component: () =>
      import(
        /*webpackChunkName: 'component-homepage' */ "@/pages/Redaktionen.vue"
      ), 
      
  },
];

export default redaktionenRoutes;
